import { render, staticRenderFns } from "./HoldSingle.vue?vue&type=template&id=592f60fe&scoped=true&"
import script from "./HoldSingle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HoldSingle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HoldSingle.vue?vue&type=style&index=0&id=592f60fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f60fe",
  null
  
)

export default component.exports